import { render, staticRenderFns } from "./_AnnualTrain.vue?vue&type=template&id=23907676&"
import script from "./_AnnualTrain.vue?vue&type=script&lang=js&"
export * from "./_AnnualTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports